<template>
    <label
        class="listing-search-input-container"
        :class="{
            'border-gray300': focused,
            'border-green500': inputted,
        }"
    >
        <div v-if="unitBefore" class="mr-5">{{ unitBefore }}</div>
        <input
            type="text"
            :value="inputValue"
            :placeholder="placeholder"
            :aria-label="placeholder"
            class="listing-search-input"
            :class="{ italic: !inputted }"
            @input="handleInput"
            @focus="focused = true"
            @blur="focused = false"
        >
        <div v-if="unitAfter" class="ml-5">{{ unitAfter }}</div>
    </label>
</template>

<script>
import addCommas from '../../helpers/addCommas';

// Search field used by residential listing filters.
export default {
    props: {
        unitBefore: { type: String, default: '' },
        unitAfter: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        modelValue: { type: [String, Number], default: '' },
        type: { type: String, default: '' },
    },
    emits: ['update:modelValue'],
    data() {
        return { focused: false, inputValue: this.formatValue(this.modelValue) };
    },
    computed: {
        inputted() {
            return Boolean(this.modelValue);
        },
    },
    watch: {
        modelValue(value) {
            this.inputValue = this.formatValue(value);
        },
    },
    methods: {
        formatValue(value) {
            const normalized = String(value ?? '').replace(/,/g, '');
            return normalized !== '' && !isNaN(normalized) && this.type !== 'text'
                ? addCommas(normalized)
                : normalized;
        },
        handleInput(event) {
            const value = event.target.value.replace(/,/g, '');
            this.inputValue = this.formatValue(value);
            this.$emit('update:modelValue', value);
        },
    },
};
</script>
